import { createContext } from 'react'
import { LoggedInUser } from 'shared/types/user'

type GifId = string | number
export type UserContextProps = {
    user: LoggedInUser
    isLoggedIn: boolean
    favorites: GifId[]
    addFavorite(id: GifId)
    removeFavorite(id: GifId)
}

const UserContext = createContext({} as UserContextProps)

export default UserContext
